export default __webpack_public_path__ + "static/media/group-211@3x.5c8387ed.png";